import React, { FC, useEffect } from "react"
import { Typography, Box, Stack, useTheme } from "@carrotfertility/carotene-core"
import { Steps } from "../workflow/steps"
import { useStateMachine } from "../../context/stateMachine/StateMachineContext"
import { useProgressTracker } from "../../views/modal/ProgressTracker"
import { IlloCalendar } from "../../views/atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "../shared"
import { FormattedMessage } from "react-intl"
import { useFlags } from "launchdarkly-react-client-sdk"

const ViewName = Steps.INSURANCE_DISCLAIMER

const InsuranceDisclaimer: FC = () => {
  const theme = useTheme()
  const { setNextStep } = useStateMachine(ViewName, null)
  const { hideProgress } = useProgressTracker()
  const flags = useFlags()

  useEffect(() => {
    hideProgress()
  }, [hideProgress])

  return (
    <>
      <Typography id="step-heading" hidden={true}>
        <FormattedMessage defaultMessage="Insurance Disclaimer" />
      </Typography>
      {/* MUI Stack spaces DOM children, so the two-element message is grouped into one child.
          The illustration's extra lg padding keeps the 48px gap the legacy Stack produced. */}
      <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "center",
            paddingBlockEnd: theme.spacing(theme.tokens.spacing.lg)
          })}
        >
          <IlloCalendar height={228} width={228} />
        </Box>
        <Box>
          <FormattedMessage
            defaultMessage="<header>Note:</header> <body>The accuracy of your answers may have legal and financial implications. If you're not sure about something,
          please check with your insurance provider, benefits portal, and/or HR department.</body>"
            values={{
              header: (content) => (
                <Typography
                  variant="h2"
                  color={(theme) => theme.palette.text.primary}
                  paddingBottom={(theme) => theme.tokens.spacing.xs}
                >
                  {content}
                </Typography>
              ),
              body: (content) => <Typography color={(theme) => theme.palette.text.secondary}>{content}</Typography>
            }}
          />
        </Box>
        <BenefitEnrollmentModalContinueButton
          onClick={() => setNextStep(ViewName, flags.insuranceEnrollmentMedicareScreens ? "" : "SKIP_MEDICARE")}
        />
      </Stack>
    </>
  )
}

export { InsuranceDisclaimer }
